module.exports = __webpack_public_path__ + "img/xczx-bg.d4caeedd.png";